export default __webpack_public_path__ + "static/media/app-logo.b4f0dd06.svg";